import React, { useEffect, useState } from 'react'
import { Modal, Table } from 'antd'
import { TablePaginationConfig } from 'antd/es/table'
import { DEFAULT_FIRST_PAGE_NUM } from '@/utils/constants'
import { ISearchPage } from '@/types/AppTypes'
import { vehicleDetialModel } from './vehicleDetialModel'
import { orderService } from '../../orderService'

export const DetialModal = () => {
    const { detialVisible: visible, setDetialVisible, SelectedId } = vehicleDetialModel()
    const initPgCfg: TablePaginationConfig = { pageSize: 10, current: DEFAULT_FIRST_PAGE_NUM }
    const [materialDataSource, setMaterialDataSource] = useState<any>([])
    const [itemDataSource, setItemDataSource] = useState<any>([])
    const [otherDataSource, setOtherDataSource] = useState<any>([])
    const [itemTotalPrice, setItemTotalPrice] = useState(0) //维修项目的总价
    const [materialTotalPrice, setMaterialTotalPrice] = useState(0) //维修项目的总价
    const [otherTotalPrice, setOtherTotalPrice] = useState(0) //维修项目的总价

    useEffect(() => {
        if (visible) {
            loadData()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible])
    const itemColumns: any = [
        {
            title: '序号',
            width: 50,
            align: 'center',
            render: (t, r, i) => i + 1,
        },
        {
            title: '项目编码',
            width: 120,
            align: 'center',
            dataIndex: 'itemCode',
        },
        {
            title: '项目名称',
            width: 200,
            align: 'center',
            dataIndex: 'itemName',
        },
        {
            title: '工时',
            width: 100,
            align: 'center',
            dataIndex: 'itemWorkHours',
            editable: true,
        },
        {
            title: '单价',
            width: 100,
            align: 'center',
            dataIndex: 'workHoursPrice',
            editable: true,
        },
        {
            title: '工时费',
            width: 100,
            align: 'center',
            dataIndex: 'workHoursPrice',
        },
        {
            title: '优惠',
            width: 100,
            align: 'center',
            dataIndex: 'preferentialAmount',
            editable: true,
        },
        {
            title: '折扣',
            width: 100,
            align: 'center',
            dataIndex: 'itemDiscount',
            editable: true,
        },
        {
            title: '总金额',
            width: 100,
            align: 'center',
            dataIndex: 'actualAmount',
        },
    ]
    const materialColumns: any = [
        {
            title: '序号',
            align: 'center',
            width: 50,
            fixed: 'left',
            render: (t, r, i) => i + 1,
        },
        {
            title: '商品编号',
            align: 'center',
            width: 200,
            fixed: 'left',
            dataIndex: 'materialCode',
            sorter: (a, b) => a.materialCode.localeCompare(b.materialCode),
        },
        {
            title: '商品名称',
            align: 'center',
            width: 200,
            fixed: 'left',
            dataIndex: 'materialName',
            sorter: (a, b) => a.materialName.localeCompare(b.materialName),
        },
        {
            title: '单价',
            align: 'center',
            width: 120,
            dataIndex: 'unitPrice',
        },
        {
            title: '数量',
            align: 'center',
            width: 120,
            dataIndex: 'materialNumber',
        },
        {
            title: '总计',
            align: 'center',
            width: 120,
            dataIndex: 'materialAmount',
        },
        {
            title: '优惠',
            align: 'center',
            width: 120,
            dataIndex: 'preferentialAmount',
        },
        {
            title: '折扣',
            align: 'center',
            width: 120,
            dataIndex: 'materialDiscount',
        },
        {
            title: '总金额',
            align: 'center',
            width: 120,
            dataIndex: 'actualAmount',
        },
    ]
    const otherColumns: any = [
        {
            title: '序号',
            align: 'center',
            width: 50,
            fixed: 'left',
            render: (t, r, i) => i + 1,
        },
        {
            title: '项目编码',
            align: 'center',
            width: 200,
            fixed: 'left',
            dataIndex: 'itemCode',
            sorter: (a, b) => a.itemCode.localeCompare(b.itemCode),
        },
        {
            title: '项目名称',
            align: 'center',
            width: 200,
            fixed: 'left',
            dataIndex: 'itemName',
            sorter: (a, b) => a.itemName.localeCompare(b.itemName),
        },
        {
            title: '单价',
            align: 'center',
            width: 120,
            dataIndex: 'unitPrice',
        },
        {
            title: '数量',
            align: 'center',
            width: 120,
            dataIndex: 'itemNumber',
        },
        {
            title: '总金额',
            align: 'center',
            width: 120,
            dataIndex: 'actualAmount',
        },
    ]

    const loadData = async (page: ISearchPage = initPgCfg) => {
        let { retData } = await orderService.getDetialOne(SelectedId)
        // const { records, ...pg } = retData
        // setPgCfg(transPgToPagination(pg))
        // setDataSource(records)
        setMaterialDataSource(retData.ciOrderMaterials)
        setItemDataSource(retData.ciOrderItems)
        setOtherDataSource(retData.ciOrderOtherItemList)
        let itemAmount: any = 0
        retData?.ciOrderItems?.forEach((item) => {
            itemAmount = Number(itemAmount) + Number(item.actualAmount)
            itemAmount = itemAmount.toFixed(2)
        })
        setItemTotalPrice(itemAmount)
        let materialAmount: any = 0
        retData?.ciOrderMaterials?.forEach((item) => {
            materialAmount = Number(materialAmount) + Number(item.actualAmount)
            materialAmount = materialAmount.toFixed(2)
        })
        setMaterialTotalPrice(materialAmount)
        let otherAmount: any = 0
        retData?.ciOrderOtherItemList?.forEach((item) => {
            otherAmount = Number(otherAmount) + Number(item.actualAmount)
            otherAmount = otherAmount.toFixed(2)
        })
        setOtherTotalPrice(otherAmount)
    }

    return (
        <Modal
            visible={visible}
            title="详情"
            onCancel={() => {
                setDetialVisible(false)
            }}
            // onOk={onOk}
            width={1200}
            footer={false}
        >
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', margin: '0 0 5px 0' }}>
                <span style={{ fontSize: '18px', fontWeight: 'bolder' }}>维修项目</span>
                <span style={{ fontSize: '15px', fontWeight: 'bolder' }}>
                    总金额&nbsp;¥&nbsp;<span style={{ fontSize: '19px', fontWeight: 'bolder', color: 'green' }}>{itemTotalPrice}</span>
                    &nbsp;元&nbsp;({itemDataSource && itemDataSource.length}项){' '}
                </span>
            </div>
            <Table
                rowKey={(record) => record.key}
                columns={itemColumns}
                dataSource={itemDataSource}
                scroll={{ x: 'max-content', y: 250 }}
                bordered
                // pagination={{
                //     ...pgCfg,
                //     position: ['bottomRight'],
                //     showTotal: () => `共${pgCfg.total}条`,
                //     onChange: (pageNum, pageSize) => {
                //         loadData({ pageNum, pageSize })
                //     },
                //     showSizeChanger: true
                // }}
                pagination={false}
            />
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', margin: '20px 0 5px 0' }}>
                <span style={{ fontSize: '18px', fontWeight: 'bolder' }}>维修物料</span>
                <span style={{ fontSize: '15px', fontWeight: 'bolder' }}>
                    总金额&nbsp;¥&nbsp;<span style={{ fontSize: '19px', fontWeight: 'bolder', color: '#ff0000' }}>{materialTotalPrice}</span>
                    &nbsp;元&nbsp;({materialDataSource && materialDataSource.length}项){' '}
                </span>
            </div>
            <Table
                rowKey={(record) => record.key}
                columns={materialColumns}
                dataSource={materialDataSource}
                scroll={{ x: 'max-content', y: 250 }}
                bordered
                // pagination={{
                //     ...pgCfg,
                //     position: ['bottomRight'],
                //     showTotal: () => `共${pgCfg.total}条`,
                //     onChange: (pageNum, pageSize) => {
                //         loadData({ pageNum, pageSize })
                //     },
                //     showSizeChanger: true
                // }}
                pagination={false}
            />
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', margin: '20px 0 5px 0' }}>
                <span style={{ fontSize: '18px', fontWeight: 'bolder' }}>其他项目</span>
                <span style={{ fontSize: '15px', fontWeight: 'bolder' }}>
                    总金额&nbsp;¥&nbsp;<span style={{ fontSize: '19px', fontWeight: 'bolder', color: '#ff0000' }}>{otherTotalPrice}</span>
                    &nbsp;元&nbsp;({otherDataSource && otherDataSource.length}项){' '}
                </span>
            </div>
            <Table
                style={{ marginBottom: '30px' }}
                rowKey={(record) => record.key}
                columns={otherColumns}
                dataSource={otherDataSource}
                scroll={{ x: 'max-content', y: 250 }}
                bordered
                // pagination={{
                //     ...pgCfg,
                //     position: ['bottomRight'],
                //     showTotal: () => `共${pgCfg.total}条`,
                //     onChange: (pageNum, pageSize) => {
                //         loadData({ pageNum, pageSize })
                //     },
                //     showSizeChanger: true
                // }}
                pagination={false}
            />
        </Modal>
    )
}
